import { GeolocationManagerStrategy } from './GeolocationManagerStrategy';

export class GeolocationManagerGeolocationApiStrategy extends GeolocationManagerStrategy {
  public watchPosition(
    successCallback: PositionCallback,
    errorCallback: PositionErrorCallback
  ): number {
    return navigator.geolocation.watchPosition(successCallback, errorCallback);
  }

  public clearWatch(watchId: number): void {
    navigator.geolocation.clearWatch(watchId);
  }
}
